module.exports = __webpack_public_path__ + "img/hddb.f8f6b336.png";